import React from 'react';
import {
  Home,
  Users,
  Image,
  FileText,
  Map,
  BarChart2,
  MessageCircle,
  Shield,
  Plane,
  Car,
} from 'lucide-react';

const AdminMenu = [
  { 
    icon: <Home />, 
    label: 'Tableau de bord', 
    path: '/admin' 
  },
  { 
    icon: <Users />, 
    label: 'Gestion de comptes', 
    path: '/gestion-de-comptes' 
  },
  
  { 
    icon: <FileText />, 
    label: 'Infos voyageurs', 
    path: '/informations-voyaeurs' 
  },
  { 
    icon: <Plane />, 
    label: 'Voyages E/S aériens', 
    path: '/voyageurs-aeriens' 
  },
  { 
    icon: <Car />, 
    label: 'Voyages E/S terrestres', 
    path: '/voyageurs-terrestres' 
  },
  { 
    icon: <Map />, 
    label: 'Voyages internes', 
    path: '/voyages-internes' 
  },
  { 
    icon: <BarChart2 />, 
    label: 'Gestion de referentiels', 
    path: '/outils' 
  },
  { 
    icon: <MessageCircle />, 
    label: 'Messagerie', 
    path: '/messagerie' 
  },
  { 
    icon: <Shield />, 
    label: 'Fonctions Avancées', 
    path: '/fonctions-avancees' 
  }
];

export default AdminMenu;